export const VARIATION = [
  'primary',
  'dark',
  'light'
]
